import React from 'react';
import * as Klaro from 'klaro';
import getKlaroConfig from '../../config/klaro';

const CookieLayer = () => (
    <button className="fixedBottomButton toggleCookieButton" onClick={() => Klaro.show(getKlaroConfig())} title="Cookie-Button">
        <i className="la la-cog" />
    </button>
);

export default CookieLayer;
